const getMentionContextTimings = ({
  words_with_times: { words, times },
  mention_text,
}: {
  words_with_times: { words: string[]; times: number[] };
  mention_text: string;
}) => {
  // Normalize the content
  const trimmedMentionText = mention_text
    .replaceAll("<b>", "")
    .replaceAll("</b>", "")
    .replaceAll("…", "");

  // Construct a full transcript
  const transcript = words.join(" ");
  const trimmedWords = mention_text.split(" ");

  // Find out where the normalized mention starts within the transcript
  const startsAt = transcript.indexOf(trimmedMentionText);

  // Find out how many words are before
  const wordsBefore = transcript.slice(0, startsAt).split(" ").length - 1 || 0;

  return {
    start: times[wordsBefore],
    end: times[wordsBefore + trimmedWords.length - 1],
  };
};

export default getMentionContextTimings;
